import axios from 'axios';

const roundCoord = (value, decimals = 3) => {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};

const getCoordinatesFromAddress = async (address) => {
  const trimmed = String(address || '').trim();
  if (!trimmed) {
    throw new Error('Address required');
  }
  const accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
  if (!accessToken) {
    throw new Error('Mapbox token missing');
  }
  const query = encodeURIComponent(trimmed);
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${accessToken}&limit=1&language=en`;
  const response = await axios.get(url);
  const feature = response?.data?.features?.[0];
  const center = feature?.center;
  if (!Array.isArray(center) || center.length < 2) {
    throw new Error('No results');
  }
  const [lon, lat] = center;
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    throw new Error('Invalid coordinates');
  }
  return {
    lat: roundCoord(lat, 3),
    lon: roundCoord(lon, 3),
  };
};

export default getCoordinatesFromAddress;
